/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PolygonCollection_jsonld } from './PolygonCollection_jsonld';
import type { TileCollection_jsonld } from './TileCollection_jsonld';
import type { ValueObject_Location_jsonld } from './ValueObject_Location_jsonld';
export type GeoPolygon_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    geoId?: string;
    geoType?: GeoPolygon_jsonld.geoType;
    polygons?: PolygonCollection_jsonld;
    tiles?: TileCollection_jsonld;
    center?: ValueObject_Location_jsonld | null;
};
export namespace GeoPolygon_jsonld {
    export enum geoType {
        CITY = 'city',
        VOIVODESHIP = 'voivodeship',
        REGION = 'region',
        COUNTRY = 'country',
    }
}
